import React, { useState } from 'react';
import { success_toaster } from '../../toaster/Toaster';

const CopyButton = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    success_toaster("Address Copied!");
  };

  return (
    <div>
      <button className='py-1 px-4 bg-themeBlue text-white rounded hover:bg-transparent hover:text-themeBlue border border-themeBlue' onClick={copyToClipboard}>
        {copied ? 'Copied!' : 'Copy'}
      </button>
    </div>
  );
};

export default CopyButton;
